// Permission helper — reads the logged-in user's permissions from localStorage
export function getUser() {
  try {
    return JSON.parse(localStorage.getItem('user') || '{}');
  } catch { return {}; }
}

export function isAdmin() {
  return getUser().role === 'admin';
}

// The logged-in user's forced driver-type restriction, or null when they're
// unrestricted (admin, or no driver_scope set on their account).
export function getDriverScope() {
  const scope = getUser().driver_scope;
  return (Array.isArray(scope) && scope.length) ? scope : null;
}

// Check if current user can do an action on a page
export function can(page, action = 'view') {
  const user = getUser();
  if (user.role === 'admin') return true;      // admin: everything
  if (user.permissions === 'ALL') return true; // safety
  const perms = user.permissions || {};
  const pagePerms = perms[page];
  if (!pagePerms) return false;
  return pagePerms[action] === true;
}

// List of all pages + their available actions (for the toggle grid)
export const PERMISSION_SCHEMA = [
  { page: 'live_map', label: 'Live Map', actions: ['view'] },
  { page: 'invoices', label: 'Invoices', actions: ['view', 'upload', 'delete'] },
  { page: 'tracking', label: 'Invoice Tracking', actions: ['view'] },
  { page: 'route_planner', label: 'Route Planner', actions: ['view', 'optimize', 'assign'] },
  { page: 'drivers', label: 'Drivers', actions: ['view', 'edit', 'delete'] },
  { page: 'driver_reports', label: 'Driver Reports', actions: ['view', 'delete'] },
  { page: 'odometer_report', label: 'Odometer Report', actions: ['view'] },
  { page: 'journey_history', label: 'Journey History', actions: ['view'] },
  { page: 'analytics', label: 'Analytics', actions: ['view'] },
  { page: 'management_report', label: 'Management Report', actions: ['view'] },
  { page: 'bc_reconciliation', label: 'BC Reconciliation', actions: ['view'] },
  { page: 'rescheduled', label: 'Rescheduled', actions: ['view', 'assign'] },
  { page: 'settings', label: 'Settings', actions: ['view', 'edit'] },
  { page: 'users', label: 'User Management', actions: ['view', 'manage'] },
];

export const ROLE_PRESETS = {
  admin: 'Full access to everything',
  supervisor: 'View all + selected edit actions',
  viewer: 'View-only: Live Map, Reports, Analytics',
};
